import { render } from "./CompanyRow.vue?vue&type=template&id=0946561e"
import script from "./CompanyRow.vue?vue&type=script&lang=ts"
export * from "./CompanyRow.vue?vue&type=script&lang=ts"
script.render = render

export default script